export interface BrandKitPreferenceProps {
  brandKitId: string;
}

export const BRAND_KIT_PREFERENCE_LABEL = 'Brand kit';

export const BRAND_KIT_PREFERENCE_LOADING_VALUE = 'Loading…';

export const BRAND_KIT_PREFERENCE_UNRESOLVED_VALUE = 'Could not be resolved';

export const BRAND_KIT_LOGO_THUMB_LABEL = 'logo';
